export class BalanceManager {
  private static balanceCents = 0;

  static set(cents: number) {
    this.balanceCents = cents;
  }

  static add(deltaCents: number) {
    this.balanceCents += deltaCents;
  }

  static get(): number {
    return this.balanceCents;
  }

  static reset() {
    this.balanceCents = 0;
  }
}